//https://github.com/callemall/material-ui/pull/3540/files#diff-cb709f74c8d04ddae1690cbca93107c7
import React from 'react';
import PropTypes from 'prop-types';

const defaultProps = {};

/**
 * Окончания числительных
 * https://gist.github.com/realmyst/1262561
 * @param {Number} number
 * @returns {string}
 */
const declOfNum = (number) => {
    const titles = ['знак', 'знака', 'знаков'];
    const cases = [2, 0, 1, 1, 1, 2];
    const currentNumber = Math.abs(number);
    return titles[(currentNumber % 100 > 4 && currentNumber % 100 < 20) ? 2 : cases[(currentNumber % 10 < 5) ? currentNumber % 10 : 5]];
};

const TextCharCount = (props) => {
    const {
        currentChar,
        maxChar,
        style,
        errorStyle,
    } = props;
    
    const styles = {
        root: {
            position: 'relative',
            float: 'right',
            fontSize: '12px',
            bottom: 8,
            color: '#777777',
            marginTop: -7,
            marginBottom: -7
        },
        error: {
            color: '#c00'
        },
    };
    
    let regularStyle = Object.assign({}, styles.root, style);
    
    let result = maxChar - currentChar;
    
    if (result > 0) {
        result = `+${result}`;
    }
    if (result < 0) {
        regularStyle = Object.assign({}, styles.root, styles.error, errorStyle)
    }
    
    if (currentChar !== 0) {
        return (
            <div style={regularStyle}>
                {result} {declOfNum(result)}
            </div>
        );
    } else {
        return (<div/>);
    }
};

TextCharCount.propTypes = {
    // Current number of character in the Textfield.
    currentChar: PropTypes.number,
    
    // Override the inline-styles of the error element.
    errorStyle: PropTypes.object,
    
    // Maximum number of character in the Textfield.
    maxChar: PropTypes.number,
    
    // Override the inline-styles of the root element.
    style: PropTypes.object
};
TextCharCount.defaultProps = defaultProps;

export default TextCharCount;


// WEBPACK FOOTER //
// src/components/ui/charCounter.js